/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GeoClassCount = {
  workStatusClass?: GeoClassCount.workStatusClass | null;
  classesCount: number;
};
export namespace GeoClassCount {
  export enum workStatusClass {
    FULL_TIME = 'FULL_TIME',
    PART_TIME = 'PART_TIME',
    SALARY = 'SALARY',
    HOURLY = 'HOURLY',
  }
}
